import React from 'react'
import BannerImageEditor from './BannerImageEditor'
import EditorialEditor from './EditorialEditor'
import VideoEmbedEditor from './VideoEmbedEditor'

interface WidgetMetadataEditorProps {
  widgetType: string
  metadata: Record<string, any>
  onChange: (metadata: Record<string, any>) => void
  /** Widget id is available once the widget exists. Required for editors that upload assets. */
  widgetId?: string
}

/** Renders the appropriate metadata editor for a given widget type */
const WidgetMetadataEditor: React.FC<WidgetMetadataEditorProps> = ({ widgetType, metadata, onChange, widgetId }) => {
  switch (widgetType) {
    case 'video_embed':
      return <VideoEmbedEditor metadata={metadata} onChange={onChange} />
    case 'editorial':
      return <EditorialEditor metadata={metadata} onChange={onChange} />
    case 'banner_image':
      return <BannerImageEditor metadata={metadata} onChange={onChange} widgetId={widgetId} />
    default:
      return <p>No editor available for {widgetType}</p>
  }
}

export default WidgetMetadataEditor
export { BannerImageEditor, EditorialEditor, VideoEmbedEditor }
